module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Abby Green\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Abby Green spent her teens reading Mills & Boon romances. She then spent many years working in the Film and TV industry as an Assistant Director. One day while standing outside an actor's trailer in the rain, she thought: "), _c('I', [_vm._v("there has to be more than this. ")]), _vm._v("So she sent off a partial to Harlequin Mills & Boon. After many rewrites, they accepted her first book and an author was born. She lives in Dublin, Ireland and you can find out more here: www.abby-green.com")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/7k8ipT/tc-custom/9781460346396.jpg?1728327163595",
      "alt": "This image is the cover for the book Call of the Desert"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Call of the Desert\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Consumed by the heat of the desert"), _c('br'), _c('br'), _vm._v("Twelve years ago Julia lost her heart to Sheikh Kaden in the scorching Burquati desert. Sizzling nights in the sand dunes under a blanket of stars made it seem as if they were the only two people in the world. Until bitter betrayal destroyed everything Julia meets Kaden again by chancealthough the cynicism in his eyes and the sharp suit covering his powerful body make the Sheikh virtually unrecognisable. Julia knows she shouldn’t ignore the warning shadows of their past, but Kaden’s earthy sexual magnetism makes the call of the desert utterly overpowering")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0